export const checkPage = (included, notIncluded) => {
  const page = window.location.href;

  return String(page).includes(included) && !String(page).includes(notIncluded);
};
